import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, signal,} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {ValuationTabComponent} from '../valuation-tab.component';

@Component({
  selector: 'app-subject-location-tab',
  templateUrl: './subject-location-tab.component.html',
  styleUrl: './subject-location-tab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
})
export class SubjectLocationTabComponent extends ValuationTabComponent<Blob> {
  protected readonly tabTitle = 'Subject Location';

  readonly imageUrl = signal<string | null>(null);
  readonly noMap = signal(false);

  constructor() {
    super();

    // No required input on this tab -- always valid, so a prior tab's
    // tabValid doesn't leak in (docs/valuation-feedback-2026-07-09.md task 5).
    this.valid.set(true);

    inject(DestroyRef).onDestroy(() => {
      const url = this.imageUrl();
      if (url) URL.revokeObjectURL(url);
    });
  }

  protected override loadData(): Observable<Blob> {
    return this.valuationService.getPropertyMap(this.sessionId()).pipe(
      tap((blob) => this.applyBlob(blob)),
    );
  }

  protected async refresh(): Promise<void> {
    const blob = await this.load(this.valuationService.refreshPropertyMap(this.sessionId()));
    if (blob) {
      this.applyBlob(blob);
      this.setData(blob);
    }
  }

  private applyBlob(blob: Blob): void {
    const previous = this.imageUrl();
    if (previous) URL.revokeObjectURL(previous);
    this.noMap.set(false);
    this.imageUrl.set(URL.createObjectURL(blob));
    // The map endpoint returns a raw Blob, so it can't carry `progress`
    // inline like every other tab's response -- refresh it separately.
    void this.sessionPage.refreshProgress();
  }
}
